import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { ProductShot } from './ProductShot';
import { CHECKOUT_URL, PRICE, offerIncludes } from '../data/content';
export function Pricing() {
  return <section id="offer" className="scroll-mt-0 border-y-4 border-mustard bg-navy px-4 py-6 text-white sm:px-6" data-id="element-172" data-mp="2oi7htn359x0n">
      <p className="text-center font-body text-[11px] font-extrabold uppercase tracking-[0.18em] text-mustard" data-id="element-173" data-mp="2jlyv9ommb1jg">
        Special launch offer
      </p>

      <h2 className="mt-1.5 text-center font-heading text-xl font-extrabold uppercase leading-none text-white sm:text-3xl" data-id="element-174" data-mp="1rthv9jgkog8c">
        👥 Senior Activity Ready™
      </h2>
      <p className="mt-1 text-center text-[12px] font-extrabold uppercase tracking-wide text-mustard sm:text-sm" data-id="element-175" data-mp="20tejjjz1vd2v">
        The complete ready-to-use activity system
      </p>
      <p className="mt-0.5 text-center text-[12px] font-semibold text-white/80 sm:text-[13px]" data-id="element-176" data-mp="3h97lty1h70sb">
        Complete 6-in-1 Senior Activity System
      </p>

      <ProductShot href={CHECKOUT_URL} size="md" className="my-3.5" data-id="element-177" data-mp="3vyf7utymt42w" />

      <div className="mx-auto max-w-md rounded-lg border-4 border-mustard bg-white p-4 text-center" data-id="element-178" data-mp="4smfitxh0a0d">
        <ul className="grid gap-1 text-left sm:grid-cols-2" data-id="element-179" data-mp="9rpatmnnf1v5">
          {offerIncludes.map(item => <li key={item} className="flex items-start gap-1.5" data-id="element-180" data-mp="erv2h2tx4od8">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-teal" strokeWidth={3} aria-hidden="true" data-id="element-181" data-mp="eoz6vl5jmbry" />
              <span className="text-[12px] font-semibold leading-snug text-graphite" data-id="element-182" data-mp="3i8bp4cyynsi7">
                {item}
              </span>
            </li>)}
        </ul>

        <div className="mt-3.5 border-t border-cream-deep pt-3" data-id="element-183" data-mp="3rywvimkvm1bo">
          <p className="text-[12px] font-bold text-graphite/70" data-id="element-184" data-mp="2uipqprqexhb9">
            Normal Price: <span className="line-through" data-id="element-185" data-mp="2ugn2nd8tly96">{PRICE.full}</span>
          </p>
          <p className="mt-0.5 text-[12px] font-extrabold uppercase tracking-wide text-terracotta" data-id="element-186" data-mp="2zfzp3wvs53b8">
            🔥 Get Senior Activity Ready™ today
          </p>
          <p className="font-heading text-5xl font-extrabold leading-none text-navy" data-id="element-187" data-mp="2mijr76n4prx3">
            {PRICE.now}
          </p>
          <p className="mt-1 text-[10px] font-bold uppercase tracking-wider text-graphite/60" data-id="element-188" data-mp="315cybomhvre7">
            One-time payment · Pay in your local currency
          </p>
        </div>

        <div className="mt-3.5" data-id="element-189" data-mp="28h7dl1vfy2ed">
          <CTAButton href={CHECKOUT_URL} tone="mustard" subLabel="Immediate Digital Access" data-id="element-190" data-mp="28i8zy2hwqbbe">
            👥 Yes! I want the complete system
          </CTAButton>
        </div>

        <p className="mt-2 text-[12px] font-bold text-navy" data-id="element-191" data-mp="2idtwvm84clea">
          🛡️ 14-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}